import React, { useState, useRef, useContext, useEffect } from 'react';
import { useParams } from 'react-router';
import { DataObjectContainer, DataObjectContext } from '../dataObjects/DataObjectContextManager';
import { ApiDataAccess } from '../infrastructure/ApiDataAccess';
import { BoundLabel, PageableList, DataSourceDropdownList, BoundTextarea } from '../dataObjects/BoundControls';
import { Popup, Confirmation } from '../core/Popup';
import { Textbox } from '../core/Textbox';
import { XSquare, Trash2 } from 'react-feather';
import { UserContext, CapabilitiesContext } from '../infrastructure/Contexts';
import { CapabilityName } from '../infrastructure/Constants';

import './AnonymousTranslationPage.css';

export const AnonymousTranslationPage = ({ applicationKey, source, target }) => {
    var timeout = null;    
    const context = useRef(null);  
    const confirmation = useRef(null);
    const popup = useRef(null);
    const list = useRef(null);
    const [recordKey, setRecordKey] = React.useState(null);
    const [filter, setFilter] = React.useState({ applicationclientid: applicationKey, sourceculture: source ? source : null, targetculture: target ? target : null, sourcephrasefilter: null, targetphrasefilter: null });
    
    const query = new URLSearchParams(window.location.search);
    const token = query.get('auth');

    const onSaved = async () => {
        list.current.refresh();
    }

    const showPopup = (recordKey) => {
        setRecordKey(recordKey);
        popup.current.show();
    }

    const onSourceCultureChanged = (val) => {
        console.log(val);
        var f = filter;
        f['sourceculture'] = val ? val : null;
        setFilter(f);
        list.current.refresh();
    }

    const onTargetCultureChanged = (val) => {
        console.log(val);
        var f = filter;
        f['targetculture'] = val ? val : null;
        setFilter(f);
        list.current.refresh();
    }

    const onSourcePhraseFilterChanged = (txt) => {
        window.clearTimeout(timeout);
        timeout = window.setTimeout(() => {
            var f = filter;
            f['sourcephrasefilter'] = txt ? txt : null;
            setFilter(f);
            list.current.refresh();
            
        }, 500);
    }

    const onCategoryFilterChanged = (txt) => {
        window.clearTimeout(timeout);
        timeout = window.setTimeout(() => {
            var f = filter;
            f['category'] = txt ? txt : null;
            setFilter(f);

            console.log(f);

            list.current.refresh();

        }, 500);
    }

    
    const onTargetPhraseFilterChanged = (txt) => {
        window.clearTimeout(timeout);
        timeout = window.setTimeout(() => {
            var f = filter;
            f['targetphrasefilter'] = txt ? txt : null;
            setFilter(f);
            list.current.refresh();

        }, 500);
    }

    const onDeleteClick = async (key) => {
        confirmation.current.show('This will delete the selected translation. The vocabulary will then need to be provided by the client application. Do you want to continue?', 'Delete Translation', async () => {
            var dataAccess = new ApiDataAccess('/api/dataobjects/token');
            await dataAccess.delete(`/translationDataObject/${key}?token=${token}`);
            list.current.refresh();
        });
    }

    return (
        <div className='iframecontent'>
            <Popup ref={popup}>
                <ApplyTranslationPopupContent popup={popup} onSaved={onSaved} recordKey={recordKey} token={token} />
            </Popup>

            <Confirmation ref={confirmation} />

            <DataObjectContainer ref={context} dataObjectName={'translationDataObject'} token={token} >
                <PageableList ref={list} pageSize={100} loadAll={true} filter={filter} defaultText={'No Translations found. Please check the applied filters.'}
                    onRenderHeaderRow={() => {
                        return (
                            <div className='row caption' >
                                <div className='cell mobile-hidden'>Validated</div>
                                <div className='cell mobile-hidden'>Category
                                     <DataSourceDropdown name={'DistinctCategories'} filter={filter} valuePropertyName={'Name'} onChanged={onCategoryFilterChanged} /> 
                                </div>
                                <div className='cell mobile-hidden'>
                                    Source Culture
                                    {!source &&
                                        <DataSourceDropdownList dataSourceName='DistinctSourceCultures' onChanged={onSourceCultureChanged} /> 
                                    }
                                </div>
                                <div className='cell'>
                                    Source Phrase
                                    <Textbox onChange={txt => { onSourcePhraseFilterChanged(txt) }} />
                                </div>
                                <div className='cell mobile-hidden'>
                                    Target Culture
                                    {!target &&
                                         <DataSourceDropdownList dataSourceName='DistinctTargetCultures' onChanged={onTargetCultureChanged} /> 
                                    }
                                </div>
                                <div className='cell'>
                                    Target Phrase
                                    <Textbox onChange={txt => { onTargetPhraseFilterChanged(txt) }} />
                                </div>
                                <div className='cell mobile-hidden text-align-right'>&nbsp;</div>
                            </div>
                        )
                    }}
                    onRenderRow={(key, item, references) => {
                        return (
                            <div className='row selectable' key={`row${key}`}>
                                <div className='cell mobile-hidden'><div className={item.validated ? 'indicator valid' : 'indicator'} /></div>

                                <div className='cell mobile-hidden' onClick={() => { showPopup(key) }}>{item.category}</div>
                                <div className='cell mobile-hidden' onClick={() => { showPopup(key) }}>
                                    <span className={`fi fi-${references.dataSources.sourceCultureId.find(e => e.id == item.sourceCultureId).countryCode}`}></span>
                                    <span>{references.dataSources.sourceCultureId.find(e => e.id == item.sourceCultureId).languageName}</span>
                                </div>

                                <div className='cell' onClick={() => { showPopup(key) }}>{item.sourceVocablePhrase}</div>

                                <div className='cell mobile-hidden' onClick={() => { showPopup(key) }}>
                                    <span className={`fi fi-${references.dataSources.targetCultureId.find(e => e.id == item.targetCultureId).countryCode} mobile-hidden`}></span>
                                    <span>{references.dataSources.targetCultureId.find(e => e.id == item.targetCultureId).languageName}</span>
                                </div>

                                <div className='cell' onClick={() => { showPopup(key) }}>{item.targetVocablePhrase}</div>
                                <div className='cell mobile-hidden text-align-right'>
                                    <button className='btn sm btn-primary-outline' onClick={() => { onDeleteClick(key) }}><Trash2 className='icon' /> Delete</button>
                                </div>
                            </div>
                        )
                    }} />
            </DataObjectContainer>

        </div>
    );
}


export const ApplyTranslationPopupContent = ({ popup, token, recordKey, onSaved }) => {

    const context = useRef(null);
    const [valid, setValid] = useState(false);
    const capabilities = useContext(CapabilitiesContext);
    const notification = capabilities.getCapability(CapabilityName.Notification);

    const onSaveClick = async () => {
        popup.current.close();
        try {
            var response = await context.current.submitAsync();

            if (onSaved) {
                onSaved(response);
            }
        }
        catch (ex) {
            var error = JSON.parse(ex);
            console.log(error);
            notification.add('error', 'Error', error.detail ? error.detail : 'The translation was not saved. Make sure that all tokens from the source phrase are used in the translation.');
        }
    }
    
    return (
        <DataObjectContainer ref={context} dataObjectName={'translationDataObject'} dataObjectId={recordKey} onValidated={valid => { setValid(valid) }} token={token} >
            <div className='topSection'>
                <div className='left'></div>
                <div className='center'><h4>New Translation</h4></div>
                <div className='right'><XSquare className='icon btn-close clickable' onClick={() => { popup.current.close() }} /></div>
            </div>

            <div className='contentSection'>

                <label htmlFor='key'>Key</label>
                <p><BoundLabel propertyName={'sourceCultureId'} />-<BoundLabel propertyName={'key'} />-<BoundLabel propertyName={'keyVariant'} />-<BoundLabel propertyName={'targetCultureId'} /></p>

                <label htmlFor='sourceVocablePhrase'>Source Vocable Phrase</label>
                <p><b><BoundLabel propertyName={'sourceVocablePhrase'} /></b></p>


                <label htmlFor='targetVocablePhrase'>Target Vocable Phrase</label>
                <BoundTextarea propertyName={'targetVocablePhrase'} rows={5} />

            </div>

            <div className='footerSection'>
                <button className='btn btn-primary btn-modal' onClick={() => { popup.current.close(); }}>Cancel</button>
                <button className='btn btn-secondary btn-modal' disabled={!valid} onClick={onSaveClick}>Save</button>
            </div>
        </DataObjectContainer>
    );
}


export const DataSourceDropdown = ({ name, filter, valuePropertyName, onChanged }) => {

    const [items, setItems] = useState(null);
    const dataObjectContextManager = useContext(DataObjectContext);

    useEffect(() => {

        const init = async () => {
            var items = await dataObjectContextManager.getDataSourceItems(name, filter);
            setItems(items);
        }

        init();

    }, []);



    const onSelection = (event) => {
        if (onChanged) {
            onChanged(event.target.value)
        }
    }

    return (
        <>
            {items &&
                <select className={`control dropdown ${name}`} onChange={onSelection}>
                    <option value={''}>All</option>
                    {items.map((item, i) => {
                        return (
                            <option key={i} value={item[valuePropertyName]}>{item.name}</option>
                        )
                    })}
                </select>
            }
        </>
    )
}